import React, {Component} from "react";
import {connect} from "react-redux";
import {AppState} from "../RootReducer";
import {Dispatch} from "redux";
import {Spinner} from "../ui/Spinner";
import {LoginStatus} from "../http/Types";
import {Redirect} from "react-router";
import {Bundle, ListBundlesResponse, RegistrationResponse, Settings, UserInfo} from "../http/protocol";
import {fetchStoreBundles, selectBundle} from "../store/StoreActions";
import {StoreStateStatus} from "../store/StoreReducer";
import {RouteComponentProps, withRouter} from "react-router-dom";
import BundleComponent from "./BundleComponent";
import ErrorBoundary from "./ErrorBoundary";
import PaymentFlow from "./PaymentFlow";
import {setUseAsStore, showCashier, updateDepositAmount} from "../payments/DepositActions";
import {GlobalPayload} from "../contenful/types";
import getLoggedInRedirect from "../utils/LoggedInRedirect";


interface State {
    animate: boolean;
    startPlaying: boolean;
}

type AllProps = PropsFromState & PropsFromDispatch & RouteComponentProps;

export class StorePage extends Component<AllProps, State> {
    constructor(props: AllProps) {
        super(props);

        this.state = {
            animate: false,
            startPlaying: false
        }
    }

    componentDidMount(): void {
        if(this.props.bundles === undefined) {
            this.props.fetchStoreBundles();
            this.props.setUseAsStore&& this.props.setUseAsStore(true);
        }
    }

    componentWillUnmount(): void {
        this.props.selectBundle(undefined); //think over this
    }

    handleOnClickBundle = (bundleId: number) => {
        let bundles = this.props.bundles;
        if(bundles !== undefined && bundles.items !== undefined) {
            if(bundleId !== undefined) {
                let bundle = bundles.items.find((bundle) => bundle.id === bundleId);
                if(bundle !== undefined) {
                    if(bundle.price&& (bundle.price.amount !== undefined && bundle.price.currency !== undefined)) {
                        this.props.update&& this.props.update(bundle.price.amount.toString());
                        this.props.selectBundle(bundleId);
                    }
                }
            }

        }
    }

    handleGoBack = () => {
        if(this.props.show&& this.props.show) { // cashiermodal is open and active
            if(this.props.selectedBundleId === undefined) {
                this.props.hide();
            } else {
                this.props.selectBundle(undefined);
            }
        } else {
            if(this.props.selectedBundleId === undefined) {
                this.props.history.goBack();
            } else {
                this.props.selectBundle(undefined);
            }
        }
    };

    handleClickStartPlaying = () => {
        this.setState({startPlaying: true});
    }

    comparePrice = (a: number | undefined, b: number | undefined) => {
        return (a || b) ? (!a ? -1 : !b ? -1 : a-b) : 0;
    }

    compare = (a: Bundle, b: Bundle) => {
        if(a.price && b.price) {
            return this.comparePrice(a.price.amount, b.price.amount);
        } else {
            return 0;
        }

    }

    render() {
        const {isFetching, bundles, loggedIn, settings, user, selectedBundleId, global, show} = this.props;

        if(this.state.startPlaying && settings) {
            return this.props && <Redirect to={getLoggedInRedirect(settings)}/>
        }

        if(user !== undefined) {
            if(!loggedIn) {
                return <Redirect to={"/"}/>
            }
        }
        return (
            <div>
                {
                    isFetching
                        ? <Spinner />
                        : (
                                <>


                                        {
                                            selectedBundleId === undefined // something more here?
                                                ? (
                                                    <div style={{paddingTop:'74.8px'}}>
                                                        {
                                                            user&& bundles&& bundles.items&& bundles.items.sort((a, b) => this.compare(a, b)).map((bundle, index) => {
                                                                return <ErrorBoundary key={index}>
                                                                    <BundleComponent
                                                                        onClick={this.handleOnClickBundle}
                                                                        key={index}
                                                                        user={user}
                                                                        bundle={bundle} />
                                                                </ErrorBoundary>
                                                            })
                                                        }
                                                    </div>
                                                )
                                                : <PaymentFlow />
                                        }

                                </>
                        )
                }
            </div>
        )
    }

}


interface PropsFromState {
    isFetching: boolean;
    status?: StoreStateStatus;
    settings?: Settings;
    loggedIn: boolean;
    bundles?: ListBundlesResponse;
    user?: UserInfo;
    selectedBundleId?: number;
    show?: boolean;
    global?: GlobalPayload;
    registration? : RegistrationResponse;
}

interface PropsFromDispatch {
    fetchStoreBundles: typeof fetchStoreBundles;
    selectBundle: typeof selectBundle;
    update? : (amount : string) => void;
    setUseAsStore? : (setUseAsStore : boolean)=>void
    hide: () => void;
}


const mapStateToProps = ({settings, store, user, payments, contentful} : AppState) => {
    return {
        isFetching: store.isFetching,
        status: store.status,
        settings: settings.settings,
        bundles: store.bundles,
        loggedIn : LoginStatus.LOGGED_IN == user.status,
        user: user.user,
        registration: user.registration,
        selectedBundleId: store.selectedBundleId,
        show : payments.cashier.showCashierModal,
        global: contentful.global
    }
}

const mapDispatchToProps = (dispatch: Dispatch) => {
    return {
        fetchStoreBundles: () => dispatch(fetchStoreBundles() as any),
        selectBundle: (bundleId?: number) => dispatch(selectBundle(bundleId) as any),
        update : (amount : string) => dispatch(updateDepositAmount(amount)),
        setUseAsStore : (useAsStore : boolean) => dispatch(setUseAsStore(useAsStore)),
        hide : () => dispatch(showCashier(false)),
    }
}


export default connect(mapStateToProps, mapDispatchToProps)(withRouter(StorePage));